import { useState } from 'react';
import { BasicAccordionBlock } from '../../types/optimizely/blocks/accordionBlock';
import { useAccordionBlockData } from './useAccordionBlockData';
import ArrowRight from '../../assets/arrow-right.svg?react';
import { Carousel } from '../Carousel/Carousel';
import Feature from '../Feature/Feature';
import {
	getBackgroundColorClassName,
	getFontColorClassName,
} from '../../lib/getColorClassNames';

export const AccordionBlock = ({ contentLink }: BasicAccordionBlock) => {
	const [currentTab, currentTabSet] = useState(0);
	const data = useAccordionBlockData(contentLink.id);

	const backgroundColorClass = getBackgroundColorClassName(
		data?.backgroundColor ?? 'color-white',
	);
	const fontColorClass = getFontColorClassName(
		data?.fontColor ?? 'color-white',
	);

	return (
		<section
			className={`py-28 ${backgroundColorClass} ${fontColorClass}`}
			id={contentLink.id}
		>
			<h1 className={`container text-4xl mb-12`}>{data?.title}</h1>
			<div className="container flex flex-row justify-between">
				<ul className="hidden lg:flex flex-col w-[350px] gap-2">
					{data?.items.map((item, index) => (
						<li
							key={index}
							className={`flex flex-row items-center justify-between rounded-3xl text-black p-2 px-6 cursor-pointer ${index === currentTab ? 'bg-primary-lightViolet text-white' : 'bg-secondary-lemon text-black'}`}
							onClick={() => currentTabSet(index)}
						>
							{item.title} <ArrowRight className={`w-[14px] h-[14px] ml-4`} />
						</li>
					))}
				</ul>
				<div className="hidden lg:flex flex-col bg-secondary-100 rounded-[16px] justify-center w-[596px] ml-8">
					{data?.items
						.filter((_, index) => index === currentTab)
						.map((item, index) => (
							<Feature
								key={index}
								description={item.description}
								imageUrl={item.imageUrl}
								title={item.title}
								showTitle={item.showTitle}
								maxWidth={false}
							/>
						))}
				</div>
			</div>
			<div className="lg:hidden">
				<Carousel
					dataLength={data?.items.length}
					className={'items-center ml-0'}
					widthOfElement={274}
				>
					{data?.items.map((item, index) => (
						<Feature
							key={index}
							description={item.description}
							imageUrl={item.imageUrl}
							title={item.title}
							showTitle={item.showTitle}
							maxWidth={true}
						/>
					))}
				</Carousel>
			</div>
		</section>
	);
};
